import { render, staticRenderFns } from "./NewCategories.vue?vue&type=template&id=be58b946&scoped=true&"
import script from "./NewCategories.vue?vue&type=script&lang=js&"
export * from "./NewCategories.vue?vue&type=script&lang=js&"
import style0 from "./NewCategories.vue?vue&type=style&index=0&id=be58b946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be58b946",
  null
  
)

export default component.exports